import Breadcrumb from './Breadcrumb.vue'

export default Breadcrumb
